<template>
  <v-container fluid class="ma-0 pa-0">
    <v-container class="overlayAddArea" v-if="areaSelected">
      <v-row align="center" justify="center">
        <v-col cols="9" class="botom-menu">
          <v-row>
            <v-col class="d-flex flex-column align-center pa-0">
              <v-btn text @click="removeLastEdge">
                <v-icon>mdi-keyboard-return</v-icon>
              </v-btn>
              <span class="text-caption">
                {{ this.translations.label_back }}
              </span>
            </v-col>
            <v-col class="d-flex flex-column align-center pa-0">
              <v-btn text @click="cleanNewPolygon">
                <v-icon>mdi-rotate-left</v-icon>
              </v-btn>
              <span class="text-caption">
                {{ this.translations.label_repeat }}
              </span>
            </v-col>
            <v-col class="d-flex flex-column align-center pa-0">
              <v-btn text @click="createResizablePolygon">
                <v-icon>mdi-vector-polygon</v-icon>
              </v-btn>
              <span class="text-caption">
                {{ this.translations.label_draw }}
              </span>
            </v-col>
            <v-col
              class="d-flex flex-column align-center pa-0"
              v-if="this.mainGroup"
            >
              <v-btn text @click="addArea">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <span class="text-caption">
                {{ this.translations.label_continue }}
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="ma-0 pa-0">
      <div ref="hereMap" id="hereMap" class="here-map__container"></div>
    </v-container>
  </v-container>
</template>

<script>
// Vuex
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
//components
import AreaNameDialog from "@/components/territory/modals/AreaNameDialog";

export default {
  name: "HereMap",
  components: {
    AreaNameDialog,
  },
  data() {
    return {
      dialogAgronomic: false,
      container: null,
      showDialogAreaName: false,
      points: [],
      edgesArea: [],
      markers: [],
      mainGroup: null,
      map: {},
      platform: {},
      uiVar: "",
      loading: false,
      apikey: process.env.VUE_APP_HERE_APIKEY,
      center: {
        lat: 21.088992,
        lng: -101.594029,
      },
      zoom: 17,
      markerSubSamples: [],
      mapIcon: {},
      markerIcon: {
        img:
          '<svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 492 496" width="99" height="100"><title>solena-flag</title><defs><image  width="456" height="469" id="img1" href="data:image/png;base64,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"/></defs><style>tspan { white-space:pre }</style><use id="Background" href="#img1" x="21" y="13" /></svg>',
      },
      groupMarkers: null,
      routeBtn: {},
      locationBtn: {},
      locationArray: [],
      polygons: [],
      currentPolygon: {},
    };
  },
  async mounted() {
    //initialize map default center Solena Planta
    this.center = {
      lat: this.areaSelected.location.lat,
      lng: this.areaSelected.location.lng,
    };
    this.initialize();
    //set current center
    this.setUpClickListener();
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("areasList", ["areaSelected"]),
  },
  methods: {
    ...mapMutations("areasList", ["SET_AREA_SELECTED"]),
    ...mapMutations(["SET_LOADER"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations("agronomic", [
      "SET_FORM",
      "SET_ISSUE_AREA",
      "CLEAN_ISSUE_AREA",
    ]),
    ...mapActions("areasList", ["getAreaById"]),
    initialize() {
      this.platform = new window.H.service.Platform({
        apikey: this.apikey,
      });

      const mapContainer = this.$refs.hereMap;
      let defaultLayers = this.platform.createDefaultLayers({
        engineType: H.Map.EngineType.HARP,
        tileSize: devicePixelRatio > 1 ? 512 : 256,
        ppi: devicePixelRatio > 1 ? 320 : 72,
      });

      //  initialize a map
      this.map = new H.Map(mapContainer,defaultLayers.raster.satellite.map, {
        center: { lat: 52.51604, lng: 13.37691 },
        zoom: 15,
        engineType: H.Map.EngineType.HARP,
        pixelRatio: window.devicePixelRatio || 1,
        tileSize: 512
      });

      // add a resize listener to make sure that the map occupies the whole container
      window.addEventListener("resize", () => this.map.getViewPort().resize());

      // implements default interactions for pan/zoom
      let behavior = new H.mapevents.Behavior(
        new H.mapevents.MapEvents(this.map)
      );

      // add UI
      let ui = H.ui.UI.createDefault(this.map, defaultLayers, "es-ES");
      this.uiVar = ui;
      // change controls position
      let zoom = ui.getControl("zoom");
      let mapSettings = ui.getControl("mapsettings");
      mapSettings.setAlignment("right-top");
      zoom.setAlignment("right-top");

      this.addPolygonsToMap();
    },

    addPolygonsToMap() {
      let statusColor = {
        NOT_ASSIGNED: "rgba(193, 193, 193, 0.7)",
        NOT_STARTED: "rgba(90, 190, 240, 0.7)",
        COMPLETED: "rgba(0, 128, 0, 0.7)",
        IN_PROGRESS: "rgba(241, 216, 89, 0.7)",
        INACCESSIBLE: "rgba(237, 42, 45, 0.7)",
        LAYOUT: "rgba(244, 159, 119, 0.7)",
      };
      let objects = [];
      let newPolygon = [];

      let area = this.areaSelected;
      if (area.polygon.length > 0) {
        // get polygons coordinates
        area.polygon.map((elem) => {
          let temp = [...newPolygon];
          temp.push(elem.lat);
          temp.push(elem.lng);
          temp.push(0);

          newPolygon = [...temp];
        });

        let color = statusColor[area.status];

        // create polygon
        let geoPolygon = new H.map.Polygon(
          new H.geo.Polygon(new H.geo.LineString([...newPolygon])),
          {
            style: { fillColor: color, lineWidth: 1, strokeColor: "#000" },
          }
        );

        geoPolygon.setData(area);
        objects.push(geoPolygon);
        this.polygons.push(geoPolygon);
        newPolygon = [];
      } else {
        let color = statusColor[area.status];

        let geoCircle = new H.map.Circle(
          // The central point of the circle
          { lat: area.location.lat, lng: area.location.lng },
          // The radius of the circle in meters
          100,
          {
            style: {
              strokeColor: "#000", // Color of the perimeter
              lineWidth: 1,
              fillColor: color, // Color of the circle
            },
          }
        );

        geoCircle.setData(area);
        objects.push(geoCircle);
        this.polygons.push(geoCircle);
      }

      // add polygons to group
      this.container = new H.map.Group({
        objects,
      });
      // add group to map
      this.map.addObject(this.container);

      this.map.getViewModel().setLookAtData({
        bounds: this.polygons[0].getBoundingBox(),
      });
    },
    createResizablePolygon() {
      if (this.points.length >= 3) {
        if (this.mainGroup) {
          this.map.removeObject(this.mainGroup);
          this.mainGroup = null;
        }
        let edges = [];
        for (let item of this.points) {
          edges.push(item.lat);
          edges.push(item.lng);
          edges.push(item.prof);
        }
        const markers = JSON.parse(JSON.stringify(edges));
        let svgCircle =
          '<svg width="20" height="20" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
          '<circle cx="10" cy="10" r="7" fill="rgb(39, 200, 97)" stroke="black" stroke-width="1"/>' +
          "</svg>";
        let polygon = new H.map.Polygon(
          new H.geo.LineString([...markers], "values lat lng alt"),
          {
            style: { fillColor: "rgba(237, 42, 45, 0.5)", lineWidth: 1 },
          }
        );

        let verticeGroup = new H.map.Group({
          visibility: false,
        });
        this.mainGroup = new H.map.Group({
          volatility: true, // mark the group as volatile for smooth dragging of all it's objects
          objects: [polygon, verticeGroup],
        });

        let polygonTimeout;

        // ensure that the polygon can receive drag events
        polygon.draggable = true;

        // create markers for each polygon's vertice which will be used for dragging
        polygon
          .getGeometry()
          .getExterior()
          .eachLatLngAlt((lat, lng, alt, index) => {
            var vertice = new H.map.Marker(
              { lat, lng },
              {
                icon: new H.map.Icon(svgCircle, { anchor: { x: 10, y: 10 } }),
              }
            );
            vertice.draggable = true;
            vertice.setData({ verticeIndex: index });
            verticeGroup.addObject(vertice);
          });

        // add group with polygon and it's vertices (markers) on the map
        // this.map.removeObjects(this.map.getObjects());
        if (this.markers.length > 0) this.map.removeObjects(this.markers);
        this.markers = [];

        this.map.addObject(this.mainGroup);
        // this.map.addObjects(this.polygons);

        // event listener for main group to show markers if moved in with mouse (or touched on touch devices)
        this.mainGroup.addEventListener(
          "pointerenter",
          (evt) => {
            if (polygonTimeout) {
              clearTimeout(polygonTimeout);
              polygonTimeout = null;
            }

            // show vertice markers
            verticeGroup.setVisibility(true);
          },
          true
        );

        // event listener for main group to hide vertice markers if moved out with mouse (or released finger on touch devices)
        // the vertice markers are hidden on touch devices after specific timeout
        this.mainGroup.addEventListener(
          "pointerleave",
          (evt) => {
            let timeout = evt.currentPointer.type == "touch" ? 1000 : 0;

            // hide vertice markers
            polygonTimeout = setTimeout(function() {
              verticeGroup.setVisibility(false);
            }, timeout);
          },
          true
        );

        // event listener for vertice markers group to change the cursor to pointer
        verticeGroup.addEventListener(
          "pointerenter",
          (evt) => {
            document.body.style.cursor = "pointer";
          },
          true
        );

        // event listener for vertice markers group to change the cursor to default
        verticeGroup.addEventListener(
          "pointerleave",
          (evt) => {
            document.body.style.cursor = "default";
          },
          true
        );

        // event listener for vertice markers group to resize the geo polygon object if dragging over markers
        verticeGroup.addEventListener(
          "drag",
          (evt) => {
            let pointer = evt.currentPointer,
              geoLineString = polygon.getGeometry().getExterior(),
              geoPoint = this.map.screenToGeo(
                pointer.viewportX,
                pointer.viewportY
              );

            // set new position for vertice marker
            evt.target.setGeometry(geoPoint);

            // set new position for polygon's vertice
            geoLineString.removePoint(evt.target.getData()["verticeIndex"]);
            geoLineString.insertPoint(
              evt.target.getData()["verticeIndex"],
              geoPoint
            );
            polygon.setGeometry(new H.geo.Polygon(geoLineString));

            // stop propagating the drag event, so the map doesn't move
            evt.stopPropagation();
          },
          true
        );
      }
    },
    async setUpClickListener() {
      this.map.addEventListener("tap", async (evt) => {
        if (!this.mainGroup) {
          let coord = await this.map.screenToGeo(
            evt.currentPointer.viewportX,
            evt.currentPointer.viewportY
          );
          this.points.push({
            lat: Number(coord.lat.toFixed(5)),
            lng: Number(coord.lng.toFixed(5)),
            prof: 0,
          });
          this.edgesArea.push({
            lat: Number(coord.lat.toFixed(5)),
            lng: Number(coord.lng.toFixed(5)),
          });
          let svg = `<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" width="10px" height="10px">
          <circle cx="5" cy="5" r="4" fill="rgb(39, 200, 97)" stroke-width="1" stroke="black" opacity="1"/>
          </svg>`;
          const domIcon = new H.map.DomIcon(svg);
          let marker = new H.map.DomMarker(
            {
              lat: coord.lat,
              lng: coord.lng,
            },
            { icon: domIcon }
          );
          this.markers.push(marker);
          this.map.addObject(marker);
        }
      });
    },
    async cleanNewPolygon() {
      try {
        if (this.mainGroup) this.map.removeObject(this.mainGroup);
        if (this.markers.length > 0) this.map.removeObjects(this.markers);
        this.mainGroup = null;
        this.points = [];
        this.edgesArea = [];
        this.markers = [];
      } catch (e) {
        console.log(e);
      }
    },
    removeLastEdge() {
      if (this.points.length > 0) this.points.pop();
      if (this.edgesArea.length > 0) this.edgesArea.pop();
      if (this.markers.length > 0) {
        let marker = this.markers[this.markers.length - 1];
        this.map.removeObject(marker);
        this.markers.pop();
      }
      if (this.mainGroup) {
        this.map.removeObject(this.mainGroup);
        this.mainGroup = null;
        if (this.points.length <= 2) this.points = [];
        if (this.edgesArea.length <= 2) this.edgesArea = [];
        this.createResizablePolygon();
      } else {
        this.mainGroup = null;
      }
    },
    async addArea() {
      this.SET_ISSUE_AREA(this.edgesArea);
      this.SET_FORM(false);
    },
    getCenter(edges) {
      let lat = 0;
      let lng = 0;

      for (let edge of edges) {
        lat += edge.lat;
        lng += edge.lng;
      }
      lat = Number((lat / edges.length).toFixed(4));
      lng = Number((lng / edges.length).toFixed(4));

      return { lat, lng };
    },
    computeSignedArea(array, radius) {
      let total = 0.0;
      let prev = array[array.length - 1];
      let prevTanLat = Math.tan((Math.PI / 2 - prev.lat * (Math.PI / 180)) / 2);
      let prevLng = prev.lng * (Math.PI / 180);

      for (let point of array) {
        let tanLat = Math.tan((Math.PI / 2 - point.lat * (Math.PI / 180)) / 2);
        let lng = point.lng * (Math.PI / 180);
        total += this.polarTriangleArea(tanLat, lng, prevTanLat, prevLng);
        prevTanLat = tanLat;
        prevLng = lng;
      }

      return Math.abs(total * (radius * radius));
    },
    polarTriangleArea(tan1, lng1, tan2, lng2) {
      let deltaLng = lng1 - lng2;
      let t = tan1 * tan2;
      return 2 * Math.atan2(t * Math.sin(deltaLng), 1 + t * Math.cos(deltaLng));
    },
    goToAgronomicManagement() {
      this.$router.back();
    },
    saveIssueArea() {},
  },
};
</script>
<style>
.H_l_top {
  margin-top: 70px !important;
}
</style>
<style scoped>
.botom-menu {
  background-color: rgba(255, 255, 255, 0.85);
  border-radius: 10px;
}
.here-map__container {
  width: auto;
  height: calc(100vh - 100px);
  margin: 0;
  padding: 0;
}
.overlayCenter {
  display: fixed;
  flex: 100%;
  top: 100px;
  z-index: 1;
  position: absolute;
}
.overlayAddArea {
  bottom: 10vh;
  z-index: 1;
  position: absolute;
}
.overlayBottom {
  display: fixed;
  flex: 100%;
  bottom: 23%;
  z-index: 1;
  position: absolute;
}
</style>
